import React, { useState, useEffect } from "react";
import "../../styles/app.css"; 
import InitialCard from "./lowerLimb-initial-cards/InitialCard";
import Summary from "../../other-components/Summary";
import TextSummary from "../../other-components/TextSummary";

/*_____________________CHECKBOX CARDS_____________________*/
import CheckboxPhysicalExam from "./lowerLimb-checkbox-cards/CheckboxPhysicalExam";
import CheckboxMedicalHistory from "./lowerLimb-checkbox-cards/CheckboxMedicalHistory";
import CheckboxXRays from "./lowerLimb-checkbox-cards/CheckboxXRays";
import CheckboxDxTreatment from "./lowerLimb-checkbox-cards/DxTreatment";
/*________________________________________________________*/

import Hip from "./lowerLimb-specific-cards/physical-exam/Hip";
import Knee from "./lowerLimb-specific-cards/physical-exam/Knee";
import NVstatusMI from "./lowerLimb-specific-cards/physical-exam/NVstatusMI";
import GeneralPhysicalExam from "./lowerLimb-specific-cards/physical-exam/GeneralPhysicalExam";
import Ankle from "./lowerLimb-specific-cards/physical-exam/Ankle";
import Foot from "./lowerLimb-specific-cards/physical-exam/Foot";

import MonoTraumaHistory from "./lowerLimb-specific-cards/medical-history/MonoTraumaHistory";
import ChronicConditions from "./lowerLimb-specific-cards/medical-history/ChronicConditions";
import OxfordKneeScore from "./lowerLimb-specific-cards/medical-history/OxfordKneeScore";
import HarrisHipClinicalScore from "./lowerLimb-specific-cards/medical-history/HarrisHipScore";
import MedicalTreatment from "./lowerLimb-specific-cards/medical-history/MedicalTreatment";

import PelvisXRayTraumat from "./lowerLimb-specific-cards/x-rays/PelvisXRayTraumat";
import FemurXRayTraumat from "./lowerLimb-specific-cards/x-rays/FemurXRayTraumat";
import TibiaXRayTraumat from "./lowerLimb-specific-cards/x-rays/TibiaXRayTraumat";
import HipXray from "./lowerLimb-specific-cards/x-rays/HipXray";
import HipRecon from "./lowerLimb-specific-cards/x-rays/HipRecon";
import KneeXray from "./lowerLimb-specific-cards/x-rays/KneeXray";
import KneeRecon from "./lowerLimb-specific-cards/x-rays/KneeRecon";
import FullLowerLimbXray from "./lowerLimb-specific-cards/x-rays/FullLowerLimbXray";


import Conservative_General_LL from "./lowerLimb-specific-cards/DxTreatment/Conservative_General_LL"
import Operative_General_LL from "./lowerLimb-specific-cards/DxTreatment/Operative_General_LL";

/*______________________INITIAL CARDS______________________*/
const description1 = "Anamnèses orthopédie et traumatologie, membre inférieur";
const description2 = "Examens cliniques standardisés, membre inférieur";
const description3 = "Bilan radiologique orthopédie et traumatologie, membre inférieur";
const description4 = "Diagnostics & plans de traitement"

const name1 = "Anamnèse";
const name2 = "Examen clinique";
const name3 = "Radiologie";
const name4 = "Dx et traitements";

const image1 = "../medical-history.png";
const image2 = "../physical-exam.png";
const image3 = "../x-rays.png";
const image4="../Treatment.webp";
/*_______________________________________________________________________________________________*/

function LowerLimb() {
  const [formDetails, setFormDetails] = useState(null);
  const [nameForm, setNameForm] = useState("");
  const [isFormSended, setIsFormSended] = useState(false);
  const [isText, setIsText] = useState(false);
/*_______________________________________________________________________________________________*/
  /*PHYSICAL EXAM BOX*/

  const [isVisibleCheckboxPhysical, setIsVisibleCheckboxPhysical] = useState(false);
  const [showSpecificPhysicalForm, setShowSpecificPhysicalForm] = useState(false);
  const [isVerticalMode, setIsVerticalMode] = useState(false);
  const [selectedPhysicalOptions, setSelectedPhysicalOptions] = useState({
    Généralités: false,
    "Status neuro-vasculaire": false,
    Hanche: false,
    Genou: false,
    Cheville: false,
    Pied:false
  });

   ////////////////////////////////////////////////////////////

  // States for selections in third-cards
  const [selectedThirdCardsOptions, setSelectedThirdCardsOptions] = useState({
    "Anamnèse mono-traumatisme": false,
    "Co-morbidités - en construction": false,
    "Genou: Oxford Knee Score": false,
    "Hanche: Harris score (anamnèse)": false,
    "Traitement en cours - en construction": false,
    "Généralités": false,
    "Hanche (examen physique)": false,
    "Genou (examen physique)": false,
    "Status neuro-vasculaire": false,
    "Cheville": false,
    "Pied":false,
    "Pelvis, traumatologie": false,
    "Fémur, traumatologie": false,
    "Tibia, péroné & rotule, traumatologie": false,
    "Hanche native": false,
    "Hanche prothétique": false,
    "Genou natif": false,
    "Genou prothétique": false,
    "Alignement membres inférieurs": false,
    "TTT conservateur générique": false,
    "TTT chirurgical, traumat générique": false,
  });

  // Count the sections in third-cards
  const countThirdCardsSelections = () => {
    return Object.values(selectedThirdCardsOptions).filter(Boolean).length;
  };  

    // Check if vertical mode should be activated.
  useEffect(() => {
    const handleResize = () => {
      const totalThirdCardsSelections = countThirdCardsSelections();
      const isWindowWideEnough = window.innerWidth > 940;

      setIsVerticalMode(totalThirdCardsSelections >= 4 && isWindowWideEnough);
    };
  
    window.addEventListener('resize', handleResize);
  
    // Execute immediately after mounting
    handleResize();
  
    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, [selectedThirdCardsOptions]);

  // To reflect the changes in the selections
useEffect(() => {
  const totalThirdCardsSelections = countThirdCardsSelections();
  
  const isWindowWideEnough = window.innerWidth > 940;

  setIsVerticalMode(totalThirdCardsSelections >= 4 && isWindowWideEnough);
}, [selectedThirdCardsOptions]); // Only depends of selectedThirdCardsOptions

  // Function to reflect the changes in third-cards
  const handleSelectedThirdCardsChange = (optionKey, isSelected) => {
    setSelectedThirdCardsOptions(prevState => {
      // Only update if the current value is different to the previous one. (True --> False) // (False --> True)
      if (prevState[optionKey] !== isSelected) {
        return {
          ...prevState,
          [optionKey]: isSelected
        };
      }
      return prevState;
    });
  };

  ////////////////////////////////////////////////////////////

  const handleSelectedPhysicalChange = (options) => {
    setSelectedPhysicalOptions(options);
  };

  const toggleVisiblePhysicalForm = () => {
    const anySelected = Object.values(selectedPhysicalOptions).some((value) => value);
    setShowSpecificPhysicalForm(anySelected);
  };

  useEffect(() => {
    if (!isVisibleCheckboxPhysical) {
      setSelectedPhysicalOptions({
        Généralités: false,
        "Status neuro-vasculaire": false,
        "Hanche (examen physique)": false,
        "Genou (examen physique)": false,
        Cheville: false,
        "Pied":false
      });
    }
  }, [isVisibleCheckboxPhysical]);

  useEffect(() => {
    const anySelected = Object.values(selectedPhysicalOptions).some((value) => value);
    if (!anySelected) {
      setShowSpecificPhysicalForm(false);
    }
  }, [selectedPhysicalOptions]);

/*_______________________________________________________________________________________________*/
  /*MEDICAL HISTORY*/

  const [isVisibleCheckboxHistory, setIsVisibleCheckboxHistory] = useState(false);
  const [showSpecificHistoryForm, setShowSpecificHistoryForm] = useState(false);
  const [selectedHistoryOptions, setSelectedHistoryOptions] = useState({
    "Anamnèse mono-traumatisme": false,
    "Genou: Oxford Knee Score": false,
    "Hanche: Harris score (anamnèse)": false,
    "Co-morbidités - en construction": false,
    "Traitement en cours - en construction": false,
  });

  const handleSelectedHistoryChange = (options) => {
    setSelectedHistoryOptions(options);
  };

  const toggleVisibleHistoryForm = () => {
    const anySelected = Object.values(selectedHistoryOptions).some((value) => value);
    setShowSpecificHistoryForm(anySelected);
  };

  useEffect(() => {
    if (!isVisibleCheckboxHistory) {
      setSelectedHistoryOptions({
        "Anamnèse mono-traumatisme": false,
        "Genou: Oxford Knee Score": false,
        "Hanche: Harris score (anamnèse)": false,
        "Co-morbidités - en construction": false,
        "Traitement en cours - en construction": false,
      });
    }
  }, [isVisibleCheckboxHistory]);

  useEffect(() => {
    const anySelected = Object.values(selectedHistoryOptions).some((value) => value);
    if (!anySelected) {
      setShowSpecificHistoryForm(false);
    }
  }, [selectedHistoryOptions]);

/*_______________________________________________________________________________________________*/
  /*X-RAYS*/

  const [isVisibleCheckboxXRays, setIsVisibleCheckboxXRays] = useState(false);
  const [showSpecificXRaysForm, setShowSpecificXRaysForm] = useState(false);
  const [selectedXRaysyOptions, setSelectedXRaysOptions] = useState({
    "Pelvis, traumatologie": false,
    "Fémur, traumatologie": false,
    "Tibia, péroné & rotule, traumatologie": false,
    "Hanche native": false,
    "Hanche prothétique": false,
    "Genou natif": false,
    "Genou prothétique": false,
    "Alignement membres inférieurs": false,
  });

  const handleSelectedXRaysChange = (options) => {
    setSelectedXRaysOptions(options);
  };

  const toggleVisibleXRaysForm = () => {
    const anySelected = Object.values(selectedXRaysyOptions).some((value) => value);
    setShowSpecificXRaysForm(anySelected);
  };

  useEffect(() => {
    if (!isVisibleCheckboxXRays) {
      setSelectedXRaysOptions({
        "Pelvis, traumatologie": false,
        "Fémur, traumatologie": false,
        "Tibia, péroné & rotule, traumatologie": false,
        "Hanche native": false,
        "Hanche prothétique": false,
        "Genou natif": false,
        "Genou prothétique": false,
        "Alignement membres inférieurs": false,
      });
    }
  }, [isVisibleCheckboxXRays]);

  useEffect(() => {
    const anySelected = Object.values(selectedXRaysyOptions).some((value) => value);
    if (!anySelected) {
      setShowSpecificXRaysForm(false);
    }
  }, [selectedXRaysyOptions]);

/*_______________________________________________________________________________________________*/

/*_______________________________________________________________________________________________*/
  /*Dx & Treatment*/

  const [isVisibleCheckboxDxTreatment, setIsVisibleCheckboxDxTreatment] = useState(false);
  const [showSpecificDxTreatmentForm, setShowSpecificDxTreatmentForm] = useState(false);
  const [selectedDxTreatmentOptions, setSelectedDxTreatmentOptions] = useState({
    "TTT conservateur générique": false,
    "TTT chirurgical, traumat générique": false,
  });

  const handleSelectedDxTreatmentChange = (options) => {
    setSelectedDxTreatmentOptions(options);
  };

  const toggleVisibleDxTreatmentForm = () => {
    const anySelected = Object.values(selectedDxTreatmentOptions).some((value) => value);
    setShowSpecificDxTreatmentForm(anySelected);
  };

  useEffect(() => {
    if (!isVisibleCheckboxDxTreatment) {
      setSelectedDxTreatmentOptions({
        "TTT conservateur générique": false,
        "TTT chirurgical, traumat générique": false,
      });
    }
  }, [isVisibleCheckboxDxTreatment]);

  useEffect(() => {
    const anySelected = Object.values(selectedDxTreatmentOptions).some((value) => value);
    if (!anySelected) {
      setShowSpecificDxTreatmentForm(false);
    }
  }, [selectedDxTreatmentOptions]);

/*_______________________________________________________________________________________________*/



  const handleFormSubmit = (details, name, text) => {
    setFormDetails(details);
    setNameForm(name);
    setIsFormSended(true);
    setIsText(text);
  };

  return (
    <>
      {!isFormSended && (
        <div className={`container ${isVerticalMode ? 'vertical-mode' : ''}`}>
          <div className="first-cards">
            <InitialCard
              name={name1}
              description={description1}
              image={image1}
              visible={isVisibleCheckboxHistory}
              setIsVisible={setIsVisibleCheckboxHistory}
            />
            <InitialCard
              name={name2}
              description={description2}
              image={image2}
              visible={isVisibleCheckboxPhysical}
              setIsVisible={setIsVisibleCheckboxPhysical}
            />
            <InitialCard
              name={name3}
              description={description3}
              image={image3}
              visible={isVisibleCheckboxXRays}
              setIsVisible={setIsVisibleCheckboxXRays}
            />

            <InitialCard
              name={name4}
              description={description4}
              image={image4}
              visible={isVisibleCheckboxDxTreatment}
              setIsVisible={setIsVisibleCheckboxDxTreatment}
            />
          </div>

          <div className="second-cards">
            {isVisibleCheckboxHistory && (
              <CheckboxMedicalHistory
                selectedOptions={selectedHistoryOptions}
                onSelectedOptionsChange={handleSelectedHistoryChange}
                handleButtonClick={toggleVisibleHistoryForm}
                showSpecificForm={showSpecificHistoryForm}
              />
            )}

            {isVisibleCheckboxPhysical && (
              <CheckboxPhysicalExam
                selectedOptions={selectedPhysicalOptions}
                onSelectedOptionsChange={handleSelectedPhysicalChange}
                handleButtonClick={toggleVisiblePhysicalForm}
                showSpecificForm={showSpecificPhysicalForm}
              />
            )}
            {isVisibleCheckboxXRays && (
              <CheckboxXRays
                selectedOptions={selectedXRaysyOptions}
                onSelectedOptionsChange={handleSelectedXRaysChange}
                handleButtonClick={toggleVisibleXRaysForm}
                showSpecificForm={showSpecificXRaysForm}
              />
            )}

            {isVisibleCheckboxDxTreatment && (
              <CheckboxDxTreatment
                selectedOptions={selectedDxTreatmentOptions}
                onSelectedOptionsChange={handleSelectedDxTreatmentChange}
                handleButtonClick={toggleVisibleDxTreatmentForm}
                showSpecificForm={showSpecificDxTreatmentForm}
              />
            )}
          </div>

          <div className="third-cards">
            {showSpecificHistoryForm && (
              <>
                {selectedHistoryOptions["Anamnèse mono-traumatisme"] && (
                  <MonoTraumaHistory
                    setNameForm={setNameForm}
                    onFormSubmit={(details) => handleFormSubmit(details, "Anamnèse mono-trauma", true)}
                    onSelectionChange={(isSelected) => handleSelectedThirdCardsChange("Anamnèse mono-traumatisme", isSelected)}
                  />
                )}
                {selectedHistoryOptions["Co-morbidités - en construction"] && (
                  <ChronicConditions
                    setNameForm={setNameForm}
                    onFormSubmit={(details) => handleFormSubmit(details, "Co-morbidités", true)}
                    onSelectionChange={(isSelected) => handleSelectedThirdCardsChange("Co-morbidités - en construction", isSelected)}
                  />
                )}
                {selectedHistoryOptions["Genou: Oxford Knee Score"] && (
                  <OxfordKneeScore
                    setNameForm={setNameForm}
                    onFormSubmit={(details) => handleFormSubmit(details, "Oxford Knee Score", true)}
                    onSelectionChange={(isSelected) => handleSelectedThirdCardsChange("Genou: Oxford Knee Score", isSelected)}
                  />
                )}
                {selectedHistoryOptions["Hanche: Harris score (anamnèse)"] && (
                  <HarrisHipClinicalScore
                    setNameForm={setNameForm}
                    onFormSubmit={(details) => handleFormSubmit(details, "Harris Hip Score", true)}
                    onSelectionChange={(isSelected) => handleSelectedThirdCardsChange("Hanche: Harris score (anamnèse)", isSelected)}
                  />
                )}
                {selectedHistoryOptions["Traitement en cours - en construction"] && (
                  <MedicalTreatment
                    setNameForm={setNameForm}
                    onFormSubmit={(details) => handleFormSubmit(details, "Traitement en cours", true)}
                    onSelectionChange={(isSelected) => handleSelectedThirdCardsChange("Traitement en cours - en construction", isSelected)}
                  />
                )}
              </>
            )}

            {showSpecificPhysicalForm && (
              <>
                {selectedPhysicalOptions.Généralités && (
                  <GeneralPhysicalExam
                    setNameForm={setNameForm}
                    onFormSubmit={(details) => handleFormSubmit(details, "Généralités", false)}
                    onSelectionChange={(isSelected) => handleSelectedThirdCardsChange("Généralités", isSelected)}
                  />
                )}
                {selectedPhysicalOptions["Hanche (examen physique)"] && (
                  <Hip
                    setNameForm={setNameForm}
                    onFormSubmit={(details) => handleFormSubmit(details, "Hanche (examen physique)", false)}
                    onSelectionChange={(isSelected) => handleSelectedThirdCardsChange("Hanche (examen physique)", isSelected)}
                  />
                )}
                {selectedPhysicalOptions["Genou (examen physique)"] && (
                  <Knee
                    setNameForm={setNameForm}
                    onFormSubmit={(details) => handleFormSubmit(details, "Genou (examen physique)", false)}
                    onSelectionChange={(isSelected) => handleSelectedThirdCardsChange("Genou (examen physique)", isSelected)}
                  />
                )}
                {selectedPhysicalOptions["Status neuro-vasculaire"] && (
                  <NVstatusMI
                    setNameForm={setNameForm}
                    onFormSubmit={(details) => handleFormSubmit(details, "Neuro-vasc", false)}
                    onSelectionChange={(isSelected) => handleSelectedThirdCardsChange("Neuro-vasc", isSelected)}
                  />
                )}
                {selectedPhysicalOptions.Cheville && (
                  <Ankle
                    setNameForm={setNameForm}
                    onFormSubmit={(details) => handleFormSubmit(details, "Cheville", false)}
                    onSelectionChange={(isSelected) => handleSelectedThirdCardsChange("Cheville", isSelected)}
                  />
                )}
                {selectedPhysicalOptions.Pied && (
                  <Foot
                    setNameForm={setNameForm}
                    onFormSubmit={(details) => handleFormSubmit(details, "Pied", false)}
                    onSelectionChange={(isSelected) => handleSelectedThirdCardsChange("Pied", isSelected)}
                  />
                )}
              </>
            )}

            {showSpecificXRaysForm && (
              <>
                {selectedXRaysyOptions["Pelvis, traumatologie"] && (
                  <PelvisXRayTraumat
                    setNameForm={setNameForm}
                    onFormSubmit={(details) => handleFormSubmit(details, "Bilan radiologique: pelvis", false)}
                    onSelectionChange={(isSelected) => handleSelectedThirdCardsChange("Pelvis, traumatologie", isSelected)}
                  />
                )}
                {selectedXRaysyOptions["Fémur, traumatologie"] && (
                  <FemurXRayTraumat
                    setNameForm={setNameForm}
                    onFormSubmit={(details) => handleFormSubmit(details, "Bilan radiologique: fémur proximal", false)}
                    onSelectionChange={(isSelected) => handleSelectedThirdCardsChange("Fémur, traumatologie", isSelected)}
                  />
                )}
                {selectedXRaysyOptions["Tibia, péroné & rotule, traumatologie"] && (
                  <TibiaXRayTraumat
                    setNameForm={setNameForm}
                    onFormSubmit={(details) => handleFormSubmit(details, "Bilan radiologique: tibia, péroné & rotule", false)}
                    onSelectionChange={(isSelected) => handleSelectedThirdCardsChange("Tibia, péroné & rotule, traumatologie", isSelected)}
                  />
                )}
                {selectedXRaysyOptions["Hanche native"] && (
                  <HipXray
                    setNameForm={setNameForm}
                    onFormSubmit={(details) => handleFormSubmit(details, "Bilan radiologique: hanche native", false)}
                    onSelectionChange={(isSelected) => handleSelectedThirdCardsChange("Hanche native", isSelected)}
                  />
                )}
                {selectedXRaysyOptions["Hanche prothétique"] && (
                  <HipRecon
                    setNameForm={setNameForm}
                    onFormSubmit={(details) => handleFormSubmit(details, "Bilan radiologique: hanche prothétique", false)}
                    onSelectionChange={(isSelected) => handleSelectedThirdCardsChange("Hanche prothétique", isSelected)}
                  />
                )}
                {selectedXRaysyOptions["Genou natif"] && (
                  <KneeXray
                    setNameForm={setNameForm}
                    onFormSubmit={(details) => handleFormSubmit(details, "Bilan radiologique: genou natif", false)}
                    onSelectionChange={(isSelected) => handleSelectedThirdCardsChange("Genou natif", isSelected)}
                  />
                )}
                {selectedXRaysyOptions["Genou prothétique"] && (
                  <KneeRecon
                    setNameForm={setNameForm}
                    onFormSubmit={(details) => handleFormSubmit(details, "Bilan radiologique: genou prothétique", false)}
                    onSelectionChange={(isSelected) => handleSelectedThirdCardsChange("Genou prothétique", isSelected)}
                  />
                )}
                {selectedXRaysyOptions["Alignement membres inférieurs"] && (
                  <FullLowerLimbXray
                    setNameForm={setNameForm}
                    onFormSubmit={(details) => handleFormSubmit(details, "Alignement membres inférieurs", false)}
                    onSelectionChange={(isSelected) => handleSelectedThirdCardsChange("Alignement membres inférieurs", isSelected)}
                  />
                )}
              </>
            )}

{showSpecificDxTreatmentForm && (
              <>
                {selectedDxTreatmentOptions["TTT conservateur générique"] && (
                  <Conservative_General_LL
                    setNameForm={setNameForm}
                    onFormSubmit={(details) => handleFormSubmit(details, "TTT conservateur générique", false)}
                    onSelectionChange={(isSelected) => handleSelectedThirdCardsChange("TTT conservateur générique", isSelected)}
                  />
                )}
                {selectedDxTreatmentOptions["TTT chirurgical, traumat générique"] && (
                  <Operative_General_LL
                    setNameForm={setNameForm}
                    onFormSubmit={(details) => handleFormSubmit(details, "TTT chirurgical, traumat générique", false)}
                    onSelectionChange={(isSelected) => handleSelectedThirdCardsChange("TTT chirurgical, traumat générique", isSelected)}
                  />
                )}
               
              </>
            )}
          </div>
        </div>
      )}

      


      {isFormSended && (
        isText ? (
          <TextSummary setIsFormSended={setIsFormSended} formDetails={formDetails} />
        ) : (
          <Summary nameSpecificCard={nameForm} setIsFormSended={setIsFormSended} formDetails={formDetails} />
        )
      )}
    </>
  );
}

export default LowerLimb;